module.exports = __webpack_public_path__ + "img/Mpos.b91d1fc0.svg";